// extracted by mini-css-extract-plugin
module.exports = {"footer":"TitleRelationshipFilterFooter_footer__37jZQ"};